import React from 'react';
import PropTypes from 'prop-types';

import AccessibleCarousel from '../AccessibleCarousel';
import { gettext, interpolate, ngettext } from '../../utils/text';

const SeriesSlider = ({ data }) => {
    const series = JSON.parse(data);

    if (!series.length) {
        return null;
    }

    const slides = series.map((item, index) => {
        const postCountText = ngettext(
            'article',
            'articles',
            item.number_of_posts,
        );

        return {
            id: item.url || index,
            className: 'series-carousel__slide',
            content: (
                <div className="serie">
                    <a
                        href={item.url}
                        style={{ backgroundImage: `url(${item.img})` }}
                    >
                        <span aria-hidden="true" />
                    </a>
                    <div className="serie-content">
                        <span>{`${item.number_of_posts} ${postCountText}`}</span>
                        <h2>
                            <a href={item.url}>{item.title}</a>
                        </h2>
                        <p>{item.excerpt}</p>
                    </div>
                </div>
            ),
            ariaLabel: interpolate(
                gettext('Series %(current)s of %(total)s'),
                {
                    current: index + 1,
                    total: series.length,
                },
                true,
            ),
        };
    });

    return (
        <AccessibleCarousel
            slides={slides}
            ariaLabel={gettext('Blog series')}
            showDots={false}
            splideOptions={{
                autoWidth: true,
                gap: '1.5rem',
            }}
            className="series-carousel"
        />
    );
};

SeriesSlider.propTypes = {
    data: PropTypes.string.isRequired,
};

export default SeriesSlider;
